// 引入富文本
import EditorBar from '@/components/wangeditor/wangeditor.vue'
export default {
    data() {
        return {
            // 富文本的内容
            edValue:'',
            // 搜索关键字
            keywordName: '',
            // 项目包数据
            tableData: [],
            // 总条数
            total: 0,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 15,
            // 项目包id
            package_id: null,
            // 通知公告数据
            noticeTableData: [],
            // 通知公告标题
            updateNoticeTitle: '',
            // 通知公告url
            updateNoticeUrl: '',
            // 通知公告内容
            noticeContent: '',
            // 通知公告id
            noticeId: '',
            // 通知公告的内容
            configNotice: '',
            // 添加公告的标题
            noticeTitle: '',
            // 添加公告的url
            noticeUrl: '',
            // 控制显示通知公告的弹窗
            showAnnouncements: false,
            // 控制显示添加公告的弹窗
            showAddNotice: false,
            // 控制显示编辑公告的弹窗
            showEditNotice: false,
            // 表单域标签的宽度
            formLabelWidth: '120px',
        }
    },
    methods: {

        // 搜索项目包
        onSearch() {
            // const name = this.keywordName
            // this.searchPackage(name)
            // console.log(keywordName)
            this.$post('publish/search', {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                type: 1,
                title: this.keywordName
            }).then(res => {
                if (res.status === 200) {
                    // console.log(res)
                    this.tableData = res.data.result.data
                    this.total = res.data.result.total
                }
            })

        },

        // 查找项目包
        // 测试开始
        //         token: this.$store.state.authority_management,
        //         offset: 0,
        //         length: 999,
        //         
        // console.log('数据已经获取到了',res)
        searchPackage(name = '') {

            this.$post('publish/search', {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                type: 1,
                keywordName: name
            }).then(res => {
                if (res.status === 200) {
                    // console.log(res)
                    this.tableData = res.data.result.data
                    this.total = res.data.result.total
                }
            })
        },

        // 添加通知公告
        addAnnouncements(data) {
            // 显示通知公告弹窗
            this.showAnnouncements = true
            // 取出package_id
            this.package_id = data.id
            // 获取当前项目包的通知公告
            this.getNoticeData()
        },

        // 显示发布公告弹窗
        showAddNoticeDialog() {
            this.showAddNotice = true
        },

        // 获取通知公告数据
        getNoticeData() {
            this.$post('product_notices/search', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 999,
                package_id: this.package_id
            }).then(res => {
                if (res.status === 200) {
                    this.noticeTableData = res.data.result.data
                }
            })
        },

        // 添加通知公告
        addNotice() {

            // console.log(this.configNotice)
            if (this.configNotice == '') {
                this.$message({
                    message: '请先保存',
                    type: 'error',
                })
                return false
            }
            this.$post('publish/insert', {
                token: this.$store.state.authority_management,
                type: 1,
                content: this.configNotice,
                title: this.noticeTitle,
                url: this.noticeUrl
            }).then(res => {
                this.$message({
                    message: '增加成功',
                    type: 'success'
                })
                this.searchPackage()
                this.getNoticeData()
                this.showAddNotice = false
                this.configNotice = ''
                this.noticeTitle = ''
                this.noticeUrl = ''
                this.noticeContent=''
                // console.log('清空了')
            })
        },

        // 点击编辑公告
        showUpdateNotice(data) {
            // console.log('aaaaaaaaaaaaaaaa', data)
            this.showEditNotice = true
            this.noticeId = data.id
            this.$post('publish/get', {
                token: this.$store.state.authority_management,
                id: data.id
            }).then(res => {
                // console.log('222222222222222', res)
                this.updateNoticeTitle = res.data.result.title
                this.updateNoticeUrl = res.data.result.url
                this.noticeContent = res.data.result.content
                this.edValue = this.noticeContent
            })
        },

        // 删除公告
        deleteNotice(id) {
            this.$confirm('此操作将删除该公告, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('publish/delete', {
                    token: this.$store.state.authority_management,
                    id: id.id
                }).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        // 获取公告数组
                        this.getNoticeData()
                        this.searchPackage()
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败'
                        })
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },

        // 富文本保存数据
        showMessageFromChild(data) {
            this.configNotice = data
        },

        // 修改公告
        updateNotice() {
            // console.log('hhhhhhhhhhhhhhhh',this.configNotice)
            
            if (this.configNotice == '' ) {
                this.$message({
                    message: '请先保存',
                    type: 'error',
                })
                return false
            } 
            this.$post('publish/update', {
                token: this.$store.state.authority_management,
                id: this.noticeId,
                content: this.configNotice,
                title: this.updateNoticeTitle,
                url: this.updateNoticeUrl
            }).then(res => {
                this.$message({
                    message: '修改成功',
                    type: 'success'
                })
                this.getNoticeData()
                this.searchPackage()
                this.showEditNotice = false
            })
        },

        // 当前页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.searchPackage()
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.searchPackage()
        }
    },
    mounted() {
        // 查找项目包
        this.searchPackage()
    },
    components: {
        EditorBar
    }
}